import { Entry, Maybe } from "../../../generated"

export interface EntryState {
  pageValue: number
  allEntries: (Maybe<Entry> | undefined)[]
  tabValue: number
  searchValue: string
  currentEntry: Maybe<Entry> | undefined
}

export const entryInitialState: EntryState = {
  pageValue: 0,
  allEntries: [],
  tabValue: 0,
  searchValue: "",
  currentEntry: null
}

export enum EntryActionType {
  SET_PAGE_VALUE = "setPageValue",
  SET_ALL_ENTRIES = "setAllEntries",
  SET_TAB_VALUE = "setTabValue",
  SET_SEARCH_VALUE = "setSearchValue",
  SET_CURRENT_ENTRY = "setCurrentEntry"
}

export type EntryAction = { type: EntryActionType.SET_PAGE_VALUE; pageValue: number } | { type: EntryActionType.SET_ALL_ENTRIES; allEntries: (Maybe<Entry> | undefined)[] } | { type: EntryActionType.SET_TAB_VALUE; tabValue: number } | { type: EntryActionType.SET_SEARCH_VALUE; searchValue: string } | { type: EntryActionType.SET_CURRENT_ENTRY; currentEntry: Maybe<Entry> | undefined }

export const entryReducer = (state: EntryState, action: EntryAction): EntryState => {
  switch (action.type) {
    case EntryActionType.SET_ALL_ENTRIES:
      return {
        ...state,
        allEntries: action.allEntries
      }

    case EntryActionType.SET_PAGE_VALUE:
      return {
        ...state,
        pageValue: action.pageValue
      }

    case EntryActionType.SET_TAB_VALUE:
      return {
        ...state,
        tabValue: action.tabValue
      }

    case EntryActionType.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue
      }

    case EntryActionType.SET_CURRENT_ENTRY:
      return {
        ...state,
        currentEntry: action.currentEntry
      }

    default:
      return state
  }
}
